document.onkeydown = function(event) {
    if (event.keyCode === 13) {
        document.forms['login'].submit();
    }
}